// ------------------------------------------------------
//  PRE-LAUNCH SAFE MOCK DATA
//  No real testimonials included (only placeholder text)
//  All AMZEN branding updated to AERZEN AIR™
// ------------------------------------------------------

// ⭐ No testimonials before launch — only placeholders for emotional quotes
export const testimonials = [
  {
    id: 1,
    name: "— Coming Soon —",
    location: "",
    rating: 5,
    comment:
      "“For the first time, I saw my child sleep peacefully… breathing pure air.” — A message we hope to receive from a mother soon.",
    date: ""
  },
  {
    id: 2,
    name: "— Coming Soon —",
    location: "",
    rating: 5,
    comment:
      "“Thank you for giving my baby the gift of pure air.” — A heartfelt note we aim to earn after launch.",
    date: ""
  }
];

// ⭐ Feature List
export const features = [
  {
    id: 1,
    title: "Advanced HEPA Filtration",
    description:
      "Medical-grade H13 HEPA captures 99.97% of dust, pollen, smoke & allergens.",
    icon: "shield"
  },
  {
    id: 2,
    title: "Smart Air Quality Monitoring",
    description:
      "Real-time PM2.5 sensor adjusts purification automatically for best results.",
    icon: "activity"
  },
  {
    id: 3,
    title: "Whisper-Quiet Operation",
    description:
      "Ultra-silent performance at just 25dB — quieter than a whisper.",
    icon: "volume-x"
  },
  {
    id: 4,
    title: "360° Air Circulation",
    description:
      "Dual-fan system ensures complete room coverage with powerful airflow.",
    icon: "wind"
  },
  {
    id: 5,
    title: "Energy Efficient",
    description:
      "Engineered for low power consumption without compromising performance.",
    icon: "zap"
  },
  {
    id: 6,
    title: "Touch Control Display",
    description:
      "Premium LED touchscreen panel with live air quality indicator.",
    icon: "smartphone"
  }
];

// ⭐ Product Listing
export const products = [
  {
    id: 1,
    name: "Zen-S",
    price: 4999,
    image:
      "https://customer-assets.emergentagent.com/job_amzen-fresh/artifacts/j2n7f0jj_zen-s.png",
    coverage: "Up to 200 sq ft",
    cadr: "150 m³/h",
    bestFor: "Small rooms, bedrooms",
    features: [
      "H13 HEPA Filter",
      "3-Speed Control",
      "LED Display",
      "Sleep Mode"
    ]
  },
  {
    id: 2,
    name: "Zen-M",
    price: 9599,
    image:
      "https://customer-assets.emergentagent.com/job_amzen-fresh/artifacts/gls63sg2_Zen-M.png",
    coverage: "Up to 400 sq ft",
    cadr: "300 m³/h",
    bestFor: "Medium rooms, living spaces",
    features: [
      "H13 HEPA Filter",
      "5-Speed Control",
      "Smart Sensor",
      "Timer Function",
      "Child Lock"
    ],
    popular: true
  },
  {
    id: 3,
    name: "Zen-L",
    price: 13999,
    image:
      "https://customer-assets.emergentagent.com/job_amzen-fresh/artifacts/qwkjxpfs_Zen-L.jpg",
    coverage: "Up to 600 sq ft",
    cadr: "450 m³/h",
    bestFor: "Large rooms, offices",
    features: [
      "H13 HEPA Filter",
      "7-Speed Control",
      "Smart Auto Mode",
      "AQI Display",
      "UV-C Sterilization",
      "App Control"
    ]
  }
];

// ⭐ Small stats section
export const airQualityStats = [
  { value: "99.97%", label: "Filtration Efficiency" },
  { value: "25dB", label: "Quiet Operation" },
  { value: "360°", label: "Air Circulation" },
  { value: "2 Year", label: "Warranty" }
];
